
import { Container, Grid, Box, Typography } from "@mui/material";
import useGtmScrollTracker from "../hooks/useGtmScrollTracker";

function Discover1() {

    const sectionRef = useGtmScrollTracker("Discover1");

  return (
    <Container ref={sectionRef}>
      <Grid container  alignItems="center">


        {/* Right Side - Image */}
        <Grid
          item
          xs={6}
          md={6}

        >
          <Box
            component="img"
            src="/homeimg/phone-1.gif"
            alt="Discover Image"
            sx={{
              width: { xs: "100%", md: "80%" },
              borderRadius: 2,
              height: { xs: "100%", md: "100%" },
              // mt: "40px",
              objectFit: "contain",
            }}
          />
        </Grid>

        {/* Left Side - Content */}
        <Grid
          item
          xs={6}
          md={6}
        

        >
          <Box>
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'Poppins' ,
                fontSize: { xs: "20px",md:"38px", sm: "48px" },
                lineHeight:{ xs: "20px",md:"38px", sm: "48px" },
                letterSpacing:"0%",
                fontWeight: 700,
                mt: { xs: "30px", sm: "0px" },
                textAlign: "left",
                color: "#374d91",
              }}
            >
              Track  Your Order
            </Typography>
            <Typography
              variant="body1"

              sx={{ textAlign: "left",
                 color:"#000000B2",
                 fontSize: { xs: "12px", sm: "18px", md:"18px"} , 
                  lineHeight:{ xs: "20px",md:"28px", sm: "28px" },
                  mt:1,fontFamily: 'Poppins', }}
            >
              Track your shipment live from our Dubai warehouse to delivery in Lebanon, every step updated in the app.            </Typography>
          </Box>
        </Grid>

      </Grid>
    </Container>
  );
}

export default Discover1;
